import React from 'react'
import { toTitleCase } from '@mobi/utils/string'
import { spacing } from '@mobi/component-library/Foundations'
import type { KambiValidReward } from '@mobi/api-types/kambi/player/reward'
import { PromoBanner } from '@mobi/betslip/Components/Common/PromoBanner'

/** Chosen reward on propose, ready to commit */
export const SelectedReward: React.FC<{ selectedReward: KambiValidReward }> = ({
  selectedReward,
}) => {
  return (
    <div style={{ marginBottom: spacing.md }}>
      <PromoBanner
        promoType='KambiReward'
        text={toTitleCase(selectedReward.rewardType.replaceAll('_', ' '))}
      />
    </div>
  )
}
